if (document.getElementById('scroll-observer')) {
    let scrollObserver = document.getElementById('scroll-observer');
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                let scroll_notice = document.getElementById("scroll_notice");
                scroll_notice.parentNode.removeChild(scroll_notice);
                observer.unobserve(scrollObserver)

            }
        })
    })

    observer.observe(scrollObserver);
}